<!-- 谈判人接单列表/谈判人去接单页面都用到这个组件 -->
<template>
  <div class="tpr_follow_list_item">
    <!-- 标签 -->
    <div class="title bb1g">
      <!-- 谈判人-去跟单页面-右上角标签  model：1 货主 2 买家  -->
      <template v-if="type === 'swGetFollow'">
        {{ $formatTime(item.createTime) }}
      </template>
      <!-- 谈判人-跟单页面-右上角标签 -->
      <template v-else-if="type == ''">
        {{ $formatTime(item.followTime) }}
      </template>
      <!-- 标签 -->
      <div v-if="type !== 'other'">
        <!-- 合并 -->
        <img
          width="21px"
          height="19px"
          style="margin-right: 8px"
          v-if="isMergeTrade"
          :src="require('@/img/pc/follow/merge.png')"
          :alt="$t('pcOrder.merged')"
        />
        <!-- 快单 -->
        <img
          width="38px"
          height="21px"
          v-if="isFastTrade"
          :src="require('@/img/pc/follow/fastOrder.png')"
          :alt="$t('mobileOrder.fastOrder')"
        />
        <div v-else class="custom_tag" :class="tagClass">
          {{ tagText }}
        </div>
      </div>
    </div>

    <!-- 商品信息 -->
    <div class="goods_box bb1g">
      <van-image class="goods_img" radius="8px" :src="item.goodsImage" />

      <div class="goods_content">
        <div class="font16">{{ item.goodsName }}</div>
        <template v-if="type === 'other'">
          <!-- 货主 -->
          <div class="custom_tag tag_blue" v-if="item.model == 1">
            {{ $t("pcFollow.seller") }}
          </div>
          <!-- 买家 -->
          <div class="custom_tag tag_green" v-if="item.model === 2">
            {{ $t("pcFollow.buyer") }}
          </div>
        </template>
        <div class="goods_info" v-else>
          <!-- 美元 -->
          <!-- 人民币 -->
          <div>
            <!-- 单价 -->
            <span class="label">{{ $t("mobile.home.unitPrice") }}</span
            >{{ $formatPrice(item.goodsPrice)
            }}{{
              item.goodsPriceUnit == 10
                ? $t("marketComponents.usDollar")
                : $t("marketComponents.yuan")
            }}
          </div>
          <div>
            <!-- 数量 -->
            <span class="label">{{ $t("pcBrand.quantity") }}</span>
            {{ item.goodsQuantity }}{{ item.goodsUnit }}
          </div>
        </div>
      </div>
    </div>
    <template v-if="type != 'other'">
      <template v-for="(person, index) in item.peopleList">
        <div class="info bb1g" v-if="person.phone" :key="index">
          <div>
            <!-- ： -->
            <span class="label"
              >{{ mobileSharedText(person.text)
              }}{{ $t("pcOrder.personLabelSeparator") }}</span
            >
            <span>{{ person.name }}</span>
          </div>
          <a
            :href="`tel:${person.phone.replace(/\D/g, '')}`"
            class="flex tel-link cblue gap_4"
          >
            <van-icon name="phone-o" size="16px" />
            {{ person.phone }}</a
          >
        </div>
      </template>
    </template>
    <!--按钮区域 -->
    <div class="button_box">
      <template v-if="type == 'other'">
        <div class="createTime">{{ $formatTime(item.createTime) }}</div>
      </template>
      <!-- 谈判人去跟单页面-抢单按钮 -->
      <template v-if="type === 'swGetFollow' || type === 'other'">
        <!-- 屏蔽该信息 -->
        <van-button size="small" @click="blockTprGetFollow(item)">{{
          $t("workflowFeedback.blockInformation")
        }}</van-button>
        <!-- 抢单 -->
        <van-button
          type="info"
          size="small"
          @click="handlerTprGetFollow(item)"
          >{{ $t("workflowFeedback.claimOrder") }}</van-button
        >
      </template>

      <!--谈判人跟单页面-按钮 -->
      <template v-else>
        <!-- 查看合同 -->
        <van-button
          size="small"
          @click="viewFastTradeContract(item)"
          v-if="isFastTrade && item.status == 2"
        >
          {{ $t("workflowFeedback.viewContract") }}
        </van-button>
        <!-- 查看详情 -->
        <van-button
          v-if="!isFastTrade"
          size="small"
          @click="viewDetail(item)"
          >{{ $t("buyOrders.viewDetails") }}</van-button
        >
        <!-- 验货 -->
        <van-button
          size="small"
          @click="goToInspection(item)"
          v-if="
            Number(this.item.type) === 1 &&
            this.item.clueId == -1 &&
            this.item.clueType == 1 &&
            this.item.isInspection
          "
        >
          {{ $t("mobileOrder.inspectGoods") }}
        </van-button>
        <!-- 确认交易合同 -->
        <van-button
          v-if="
            item.type === 30 &&
            item.model === 1 &&
            item.identity === 20 &&
            item.status == 1 &&
            item.orderId > 0
          "
          type="info"
          size="small"
          @click="confirmTradeContract(item)"
          >{{ $t("contractReview.confirmTradeContract") }}</van-button
        >
        <!-- 生成交易合同 -->
        <!-- 快捷 -->
        <van-button
          v-if="
            item.type === 30 &&
            item.model === 2 &&
            item.identity === 20 &&
            item.status == 1
          "
          type="info"
          size="small"
          @click="onImproveInfo(item)"
          ><span v-if="isFastTrade">{{ $t("workflowFeedback.quick") }}</span
          >{{ $t("devUpdates.generateTradeContract") }}</van-button
        >
        <!-- 快捷生成采购合同 -->
        <van-button
          v-if="item.model === 1 && item.status == 1 && isFastTrade"
          type="info"
          size="small"
          @click="onImproveInfo(item)"
          >{{ $t("workflowFeedback.quickPurchaseContract") }}
        </van-button>
        <!-- 去支付 -->
        <van-button
          v-if="item.status == 5"
          type="info"
          size="small"
          @click="onPay(item)"
          >{{ $t("workflowFeedback.goPay") }}</van-button
        >
      </template>
    </div>
  </div>
</template>

<script>
import { mobileSharedText } from "@/i18n/common/index.js";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  computed: {
    // 标签样式类名
    tagClass() {
      const { type, model } = this.item;
      // 抢单页面标签逻辑
      if (this.type === "swGetFollow") {
        return model === 1 ? "tag_blue" : "tag_green";
      }
      // 跟单页面标签逻辑
      const classMap = {
        "20_1": "tag_blue", // type=20,model=1
        "20_2": "tag_green", // type=20,model=2
        "30_1": "tag_blue", // type=30,model=1
        "30_2": "tag_green", // type=30,model=2
      };
      return classMap[`${type}_${model}`] || "";
    },
    // 标签文本内容
    tagText() {
      const { type, model } = this.item;
      // 抢单页面标签文本
      if (this.type === "swGetFollow") {
        return model === 1 ? "货主" : "买家";
      }
      // 跟单页面标签文本
      const textMap = {
        "20_1": "货主货源商务",
        "20_2": "购买商品商务",
        "30_1": "货主交易商务跟单",
        "30_2": "买家交易商务跟单",
      };

      return textMap[`${type}_${model}`] || "";
    },
    isFastTrade() {
      return this.item.clueId == -1 && this.type !== "swGetFollow";
    },
    isMergeTrade() {
      return (
        this.item.multiOrder != null &&
        this.item.multiOrder &&
        this.type !== "swGetFollow"
      );
    },
  },
  methods: {
    mobileSharedText,
    // 去验货页面
    goToInspection(item) {
      this.$router.push("/myxg/myYanHuoDetail2?goodsCode=" + item.goodsCode);
    },
    // 查看谈判人跟单详情
    viewDetail(item) {
      this.$router.push("/follow/swFollowDetail/" + item.id);
    },
    // 查看合同
    viewFastTradeContract(item) {
      // model 1 采购商务-采购订单 2 销售商务-销售订单
      if (item.model == 2) {
        this.$router.push(
          `/follow/fastTradeContractDetail?id=${item.preOrderId}`
        );
      } else {
        this.$router.push(
          `/follow/confirmFastPurchaseContract?id=${item.contractId}`
        );
      }
    },
    // 抢单
    handlerTprGetFollow(item) {
      this.$emit("sw-get-follow", item);
    },
    // 屏蔽该信息
    blockTprGetFollow(item) {
      this.$emit("sw-block-follow", item);
    },
    // 完善合同
    onImproveInfo(item) {
      if (this.isFastTrade) {
        let path = "";
        // model 1 采购商务-采购订单 2 销售商务-销售订单
        if (item.model === 1) {
          path = `/follow/fastPurchaseContract?id=${item.ownerUserId}&goodsCode=${item.goodsCode}`;
        } else {
          path = `/follow/fastTradeContract?id=${item.ownerUserId}&orderId=${item.preOrderId}`;
        }
        this.$router.push(path);
      } else {
        this.$router.push("/follow/generateTradeContract?id=" + item.id);
      }
    },
    // 确认交易合同
    confirmTradeContract(item) {
      this.$router.push(
        "/follow/confirmTradeContract?orderId=" +
          item.orderId +
          "&followId=" +
          item.id
      );
    },
    // 去支付
    onPay() {
      // Toast('去支付')
      this.$router.push("/externalPay");
    },
  },
};
</script>

<style lang="less" scoped>
.tpr_follow_list_item {
  font-size: 14px;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    font-size: 13px;
    color: rgba(59, 59, 59, 0.8);
  }

  .goods_box {
    display: flex;
    padding: 18px 0;
    .goods_img {
      width: 22%;
      // 高度和宽度保持一致
      aspect-ratio: 1/1;
      margin-right: 18px;
    }
    .goods_content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: start;
      .goods_info {
        display: flex;
        align-items: center;
        gap: 16px;
      }
    }
  }

  //信息展示-电话
  .info {
    padding: 12px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  // 标题名称
  .label {
    margin-right: 8px;
    color: #999;
    display: inline-block;
  }

  .button_box {
    padding-top: 18px;
    display: flex;
    align-content: center;
    justify-content: flex-end;
    gap: 10px;
    .createTime {
      font-size: 12px;
      color: rgba(59, 59, 59, 0.5);
      margin-right: auto;
    }
    .van-button {
      border-radius: 8px !important;
      font-size: 14px !important;
      padding: 7px 15px !important;
    }
  }
}
</style>
